module.exports = __webpack_public_path__ + "./fonts/VTFRedzone-SemiBold.ttf";